<!-- eslint-disable -->
<template lang="pug">
    .multiplayer-game-menu__selectors
        cs-multiselect.selector.examples-type-selector(
            :multiple="true",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :hide-selected='true',
            :allow-empty="false",
            :max="2",
            label="label",
            :value="selectedExamplesTypes",
            :options="examplesTypes",
            :disabled="gameState === 'started'",
            @select="selectedExamplesTypes.push($event)",
            @remove="removeSelectedExamplesType",
        )
        cs-multiselect.selector.divisible-multiplier-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            label="value",
            :close-on-select="true",
            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier')",
            :allow-empty="false",
            v-model="selectedDivisibleMultiplierValue",
            :options="difficultyOptions",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier') }}:
                |
        cs-multiselect.selector.divider-multiplier-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            label="value",
            :close-on-select="true",
            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier')",
            :allow-empty="false",
            v-model="selectedDividerMultiplierValue",
            :options="dividerMultiplierOptions",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier') }}:
                |
        cs-multiselect.selector.players-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            v-model="playersAmount",
            :options="players",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameSetting_players') }}:
                |
</template>

<script>
    /*eslint-disable*/
    import MultiplayerOptionsMixin from "../../../utils/multiplayer/optionsMixin";
    import { cloneDeep } from "lodash";

    const MULTIPLY_ACTION = 'multiply';
    const DIVIDE_ACTION = 'divide';
    const COMMON_PARAMETERS_CHANGED_EVENT = 'commonParametersHasChanged';

    export default {
        mounted () {
            this.selectedExamplesTypes = this.examplesTypes.filter(type => {
                if (this.commonParams.operations.multiply && this.commonParams.operations.divide) {
                    return true;
                } else if (this.commonParams.operations.multiply) {
                    return type.action === MULTIPLY_ACTION;
                } else if (this.commonParams.operations.divide) {
                    return type.action === DIVIDE_ACTION;
                }
                return false;
            });
            this.selectedDivisibleMultiplierValue = this.difficultyOptions.find(option => {
                return this.commonParams.digitCapacity.left.includes(option.value);
            });
            this.selectedDividerMultiplierValue = this.dividerMultiplierOptions.find(option => {
                return this.commonParams.digitCapacity.right.includes(option.value);
            });
            //set first multiselect tags to be in one height with another
            let examplesTypeMultiselectTags = document.querySelector('.multiselect__tags');
            if (examplesTypeMultiselectTags) {
                examplesTypeMultiselectTags.style.cssText = 'padding: 8px 15px';
            }
        },
        mixins: [MultiplayerOptionsMixin],
        watch: {
            selectedExamplesTypes: {
                handler (value, oldValue) {
                    if (value) {
                        if (!value.some(type => type.action === MULTIPLY_ACTION)) {
                            this.commonParams.operations[MULTIPLY_ACTION] = false;
                        }
                        if (!value.some(type => type.action === DIVIDE_ACTION)) {
                            this.commonParams.operations[DIVIDE_ACTION] = false;
                        }
                        value.forEach(type => this.commonParams.operations[type.action] = true);
                        if (oldValue !== null) {
                            this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {
                                setOperationsValues: true,
                                names: [MULTIPLY_ACTION, DIVIDE_ACTION],
                                values: [
                                    this.commonParams.operations[MULTIPLY_ACTION],
                                    this.commonParams.operations[DIVIDE_ACTION]
                                ]
                            });
                        }
                    }
                },
                immediate: true
            },
            selectedDivisibleMultiplierValue: {
                handler (value, oldValue) {
                    if (value) {
                        this.commonParams.digitCapacity.left = [value.value];
                        if (oldValue !== null) {
                            this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {
                                name: 'left',
                                value: this.commonParams.digitCapacity.left,
                            });
                            if (this.commonParams.digitCapacity.left[0] < this.commonParams.digitCapacity.right[0]) {
                                this.selectedDividerMultiplierValue = this.dividerMultiplierOptions.find(option => option.value === this.commonParams.digitCapacity.left[0]);
                            }
                        }
                    }
                },
                immediate: true
            },
            selectedDividerMultiplierValue: {
                handler (value, oldValue) {
                    if (value) {
                        this.commonParams.digitCapacity.right = [value.value];
                        if (oldValue !== null) {
                            this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {
                                name: 'right',
                                value: this.commonParams.digitCapacity.right,
                            });
                        }
                    }
                },
                immediate: true
            }
        },
        data () {
            return {
                selectedExamplesTypes: null,
                examplesTypes: [
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_multiplication'),
                        action: MULTIPLY_ACTION,
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_division'),
                        action: DIVIDE_ACTION,
                    }
                ],
                selectedDivisibleMultiplierValue: null,
                selectedDividerMultiplierValue: null,
                difficultyOptions: [
                    {
                        value: 1,
                        label: this.$i18n.t('common.common_gameSetting_digitCapacity1'),
                        $isDisabled: false,
                    },
                    {
                        value: 2,
                        label: this.$i18n.t('common.common_gameSetting_digitCapacity2'),
                        $isDisabled: false,
                    },
                    {
                        value: 3,
                        label: this.$i18n.t('common.common_gameSetting_digitCapacity3'),
                        $isDisabled: false,
                    },
                    {
                        value: 4,
                        label: this.$i18n.t('common.common_gameSetting_digitCapacity4'),
                        $isDisabled: false,
                    },
                    {
                        value: 5,
                        label: this.$i18n.t('common.common_gameSetting_digitCapacity5'),
                        $isDisabled: false,
                    },
                    {
                        value: 6,
                        label: this.$i18n.t('common.common_gameSetting_digitCapacity6'),
                        $isDisabled: false,
                    },
                    {
                        value: 7,
                        label: this.$i18n.t('common.common_gameSetting_digitCapacity7'),
                        $isDisabled: false,
                    },
                    {
                        value: 8,
                        label: this.$i18n.t('common.common_gameSetting_digitCapacity8'),
                        $isDisabled: false,
                    }
                ]
            }
        },
        methods: {
            removeSelectedExamplesType (removedType) {
                this.selectedExamplesTypes = this.selectedExamplesTypes.filter(type => type.action !== removedType.action);
            }
        },
        computed: {
            dividerMultiplierOptions () {
                let options = cloneDeep(this.difficultyOptions);
                options.forEach(option => {
                    option.$isDisabled = !this.selectedDivisibleMultiplierValue || this.selectedDivisibleMultiplierValue.value < option.value;
                });
                return options;
            }
        }
    }
</script>

<style scoped lang="scss">
    .multiplayer-game-menu__selectors {
        display: flex;
        width: 80%;
        margin: 20px;
    }
    .selector {
        margin: 0 10px;
        max-height: 44px;
        &:first-child {
            margin-left: 0;
        }
        @media screen and (max-width: 1439px) {
            max-width: 175px;
        }
    }
</style>